<template>
  <v-row class="pa-3">
    <v-col sm="6" cols="12" md="4">
      <v-card class="mx-auto" color="light-green" dark>
        <v-card-title>
          <v-icon large left> mdi-calendar </v-icon>
          <span class="title font-weight-light">Volgende verkoop</span>
        </v-card-title>

        <v-card-text class="headline font-weight-bold">
          {{ formattedNextSaleDate }}
        </v-card-text>
      </v-card>
    </v-col>
    <v-col sm="6" cols="12" md="4">
      <v-card class="mx-auto" color="light-green darken-1 " dark>
        <v-card-title>
          <v-icon large left> mdi-calendar </v-icon>
          <span class="title font-weight-light">Aantal bestellingen</span>
        </v-card-title>

        <v-card-text class="headline font-weight-bold">
          {{ orders.length }}
        </v-card-text>
      </v-card>
    </v-col>
    <v-col sm="6" cols="12" md="4">
      <v-card class="mx-auto" color="light-green darken-2" dark>
        <v-card-title>
          <v-icon large left> mdi-calendar </v-icon>
          <span class="title font-weight-light">Aantal kisten</span>
        </v-card-title>

        <v-card-text class="headline font-weight-bold">
          {{ orders.reduce((a, b) => +a + +b.box_amount, 0) }}</v-card-text
        >
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-card :loading="loading.orders">
        <v-simple-table
          ><thead>
            <tr>
              <th>Naam</th>
              <th>Aantal kisten</th>
              <th>Geaccepteerd</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="order in orders" :key="order.id" @click="open(order)">
              <td>{{ order.name }}</td>
              <td>{{ order.box_amount }}</td>
              <td>
                <v-icon :color="order.accepted ? 'green' : 'red'">{{
                  order.accepted ? "mdi-check" : "mdi-close"
                }}</v-icon>
                <v-icon right v-if="!order.accepted && order.sendSMS" class="warning--text">
                  mdi-message-text-clock 
                </v-icon>
                <v-icon right v-if="order.accepted && order.sendSMS" class="success--text" @click.stop="alert(order.phone)">
                  mdi-message-arrow-right 
                </v-icon>
              </td>
            </tr>
          </tbody></v-simple-table
        >
      </v-card>
    </v-col>
    <v-col cols="12" md="6">
      <v-btn
        color="light-green"
        style="width: 100%; height: 100%"
        class="white--text"
        min-height="100px"
        :disabled="orders.length == 0"
        @click="$router.push('/printout/' + d)"
        ><span> <v-icon left large>mdi-printer</v-icon></span></v-btn
      >
    </v-col>
    <OrderDetails
      :visible="dialogs.details"
      @close="dialogs.details = false"
      :order="selectedItem"
    />
  </v-row>
</template>

<script>
import moment from "moment";
import { firestore } from "firebase";
import OrderDetails from "@/components/OrderDetails";
export default {
  data() {
    return {
      nextSaleDate: moment(),
      orders: [],
      selectedItem: {},
      dialogs: {
        details: false,
      },
      loading: {
        orders: false,
      },
      d: "",
    };
  },
  components: {
    OrderDetails,
  },
  mounted() {
    this.findNextSaleDate();
    this.fetchOrders();
    let _self = this;
    firestore()
      .collection("Orders")
      .where("saleDate", "==", moment(this.nextSaleDate).format("YYYY-MM-DD"))
      .where("concept", "==", false)
      .onSnapshot(() => {
        _self.fetchOrders();
      });
  },
  watch: {
    nextSaleDate: "fetchOrders",
  },
  computed: {
    formattedNextSaleDate() {
      return moment(this.nextSaleDate).lang("nl").format("dddd D MMMM");
    },
  },
  methods: {
    findNextSaleDate() {
      let now = moment();
      console.log(parseInt(now.format("d")));
      switch (parseInt(now.format("d"))) {
        case 0:
          //is sunday
          now.add(2, "days");
          break;
        case 1:
          //is maandag
          now.add(1, "days");
          break;
        case 2:
          //is dinsdag
          now.add(2, "days");
          break;
        case 3:
          //is woensdag
          now.add(1, "days");
          break;
        case 4:
          //is donderdag
          now.add(1, "days");
          break;
        case 5:
          //is vrijdag
          now.add(4, "days");
          break;
        case 6:
          //is vrijdag
          now.add(3, "days");
          break;
      }

      this.nextSaleDate = now;
    },
    async fetchOrders() {
      let _self = this;
      this.d = moment(this.nextSaleDate).format("YYYY-MM-DD");
      this.loading.orders = true;
      let o = await firestore()
        .collection("Orders")
        .where("saleDate", "==", moment(this.nextSaleDate).format("YYYY-MM-DD"))
        .where("concept", "==", false)
        .get();
      _self.orders = [];
      o.forEach((order) => {
        _self.orders.push({ id: order.id, ...order.data() });
      });
      console.log(this.orders);
      this.loading.orders = false;
    },
    open(order) {
      this.selectedItem = order;
      this.dialogs.details = true;
    },
    alert(text){
      alert(`SMS verzonden naar ${text}`)
    }
  },
};
</script>

<style scoped>
.v-slide-group__prev {
  display: none !important;
}
</style>